import { REQUEST_METHOD } from 'utils/apiClient'
import { APIRoute } from 'routes/api'
import { LOGS_REQUEST } from 'utils/logs'
import { createApiThunk } from 'utils/thunkWrapper'

export const getGame = createApiThunk<Game, number>({
  action: 'game',
  method: REQUEST_METHOD.GET,
  formatUrl: (id) => APIRoute.GET_GAME(id),
})

export const updateGame = createApiThunk<Game, GamePayload>({
  action: 'game/update',
  method: REQUEST_METHOD.PUT,
  formatUrl: (payload) => APIRoute.PUT_UPDATE_GAME(payload.id),
  getData: (payload) => payload.data,
  getSuccessMessage: (payload) => payload.successMessage,
})

export const getGameFormats = createApiThunk<GameFormat[], void>({
  action: 'game/formats',
  method: REQUEST_METHOD.GET,
  formatUrl: () => APIRoute.GET_GAME_FORMATS,
})

export const deleteGame = createApiThunk<void, number>({
  action: 'game/delete',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (id) => APIRoute.DELETE_GAME(id),
})

export const deleteGameRound = createApiThunk<void, DeleteGameRoundPayload>({
  action: 'game/delete-round',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (payload) => APIRoute.DELETE_GAME_ROUND(payload.gameId, payload.roundId),
})

export const deleteGamePlayer = createApiThunk<void, DeleteGamePlayerPayload>({
  action: 'game/deletePlayer',
  method: REQUEST_METHOD.DELETE,
  formatUrl: (payload) => APIRoute.DELETE_GAME_PLAYER(payload.gameId, payload.playerId),
})

export const getGameLogs = createApiThunk<LogsResponse, GameLogsPayload>({
  action: 'game/logs',
  method: REQUEST_METHOD.GET,
  formatUrl: (payload) => APIRoute.GET_GAME_LOGS(payload.gameId),
  getParams: (payload) => payload.params,
  onSuccess: (payload, response, thunkApi) => {
    const data = response
    if (data.queryId) {
      thunkApi.dispatch(getGameLogs({ gameId: payload.gameId, params: { queryId: data.queryId } }))
    } else if (data.status === LOGS_REQUEST.Running) {
      thunkApi.dispatch(getGameLogs({ gameId: payload.gameId }))
    }
  },
})
